import { useEffect } from "react";
import { AsyncLoader } from "../../common-loader/hooks/useAsyncLoader";
import { useAppendToast } from "../../shipping/hooks/useAppendToast";

export function useSubmitErrorToasts<T = null>(loader: AsyncLoader<T>) {
  const appendToast = useAppendToast();

  const isErrors = loader.tag === "errors";
  useEffect(() => {
    if (isErrors) {
      loader.errors.forEach((error) => {
        appendToast({ message: error, tag: "danger" }, loader.key);
        return;
      });
      return;
    } else {
      return;
    }
  }, [isErrors]);
}
